import { apolloClient } from "@td/ui";
import UPDATE_PANEL_VIEW_PREFERENCES_MUTATION from "../mutations/update-panel-view-preferences.graphql";

const updatePreferredSpecialty = async (specialty) => {
  const { data: { updatePanelViewPreferences }} = await apolloClient.mutate({
    mutation: UPDATE_PANEL_VIEW_PREFERENCES_MUTATION,
    variables: {
      payload: {
        specialty
      },
    },
  });

  return updatePanelViewPreferences;
};

export default updatePreferredSpecialty;
